import { render, staticRenderFns } from "./MFA_Activation.vue?vue&type=template&id=22c64bbf"
import script from "./MFA_Activation.vue?vue&type=script&lang=ts"
export * from "./MFA_Activation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports